import { cva } from "class-variance-authority";

export const tooltipVariants = cva(
  "animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-fit origin-(--radix-tooltip-content-transform-origin) rounded-md px-3 py-1.5 text-xs text-balance",
  {
    variants: {
      variant: {
        primary: "bg-primary text-primary-foreground",
        card: "bg-background text-foreground border shadow-md p-3 rounded-lg",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  },
);

export const tooltipArrowVariants = cva(
  "z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px]",
  {
    variants: {
      variant: {
        primary: "bg-primary fill-primary",
        card: "bg-background fill-background",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  },
);
